import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { useEffectiveGrants } from '@/lib/me'

/**
 * Whether the signed-in user may open the approvals inbox, as the server
 * answers it: `approval.view`, or being an approver at all (a direct manager
 * with any role, or a person or role an approval path names). The role alone
 * cannot answer this, and `/me` does not carry it (Identity knows nothing
 * about approvals). Shared by the inbox route and the dashboard entry points.
 */
export const approvalsAccessQuery = queryOptions({
  queryKey: ['approvals', 'access'],
  staleTime: 60_000,
  queryFn: async (): Promise<boolean> => {
    const { data } = await api.GET('/approvals/access')
    return data?.data.can_open ?? false
  },
})

/** The grant answers most users at once; only the rest ask the server. */
export function useApprovalsAccess(): boolean {
  const granted = useEffectiveGrants().can('approval.view')
  const asked = useQuery({ ...approvalsAccessQuery, enabled: !granted })
  return granted || (asked.data ?? false)
}
